export default class IntersectionObserverManager {
    static allTargets = new WeakMap();
    static allObservers = new Map();

    static getInstance(onIntersection, options, ref) {
        const key = Object.values(options).join(',');
        const observer = IntersectionObserverManager.allObservers.get(key);

        IntersectionObserverManager.allTargets.set(ref, {onIntersection});

        if (!observer) {
            const newObserver = new IntersectionObserver(IntersectionObserverManager.onChange, options);
            IntersectionObserverManager.allObservers.set(key, newObserver);
            return newObserver;
        }

        return observer;
    }

    static onChange(entries) {
        entries.forEach((entry) => {
            const {target} = entry;
            const instance = IntersectionObserverManager.allTargets.get(target);
            if (instance) {
                instance.onIntersection(entry);
            }
        });
    }
}
